$('.site-header__cart-count').removeClass('hide');
// Create Pop Up Cart
let pop_up_cart = `
    <div id="box-pop-up-cart" class="box-pop-up-cart">
        <div class="title">CART</div>
        <button class="cart-popup--close" aria-label="Close" data-cart-popup-close=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" class="layer"></path></svg></button>
        <div class="list-item">
        </div>
        <div class="footer">
            <div class="alert-error">
                This item in your cart has only one pair left in your preferred size.
            </div>
            <div class="total-price"></div>
            <a href="/checkout">Checkout</a>
            <button class="cart-pop-up-continue-shipping" >
                Continue shopping
            </button>
            <a href="/account?view=member" class="cta-redeem-insider">Click To Redeem Insider Rewards Points</a>
        </div>
    </div>

`;

$("body").append(pop_up_cart);

// Get Cart
function getCart() {
    $.getJSON("/cart.js", function (cart) {
        document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: cart,
            })
        );
        $(".box-pop-up-cart .list-item .box-items").remove();
        $(".data-cart-count").text(cart.item_count);
        let cartData = cart.items;
        if (cart.item_count > 0) {
            refreshCart(cart, cartData);
        }
    });
}

$(".change-item").click(function () {
    alert("click add or min");
});

// Refresh Cart
function refreshCart(cart, cartData) {
    let data_list_item = "";
    let final_line_price = 0;
    const formatRupiah = (money) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
        }).format(money);
    };
    $.each(cartData, function (index, value) {
        var pricena = "" + value.final_line_price + "";
        var pricenaFormat = pricena.substring(0, pricena.length - 2);
        let variant = value.variant_options.toString();
        variant = variant.replace(",", " / ");
        final_line_price = final_line_price + value.final_line_price;
        data_list_item += `
        <div class="box-items"">
            <div class="box-image">
                <img src="${value.image}" alt="${value.title}"/>
                <h4 class="variant">${variant}</h4>
            </div>
            <div class="box-description">
                <h4 class="title">${value.product_title}</h4>
                <div class="price">${formatRupiah(pricenaFormat)}</div>
                <div class="line-item-operations">
                <button type="button" data-variant-id="${
                    value.variant_id
                }" data-quantity="${
        value.quantity
    }" class="button change-item">-</button>
               
                    <input type="number" disabled class="input-value" value="${
                        value.quantity
                    }" />
                    <button type="button" data-variant-id="${
                        value.variant_id
                    }" data-quantity="${
            value.quantity
        }" class="button change-item">+</button>
                </div>
            </div>
        </div>
    `;
    });


    $(".total-price").text(formatRupiah(final_line_price/100));
    $(".box-pop-up-cart .list-item").append(data_list_item);

    $(".change-item").click(function () {
        var idnaItem = $(this).attr("data-variant-id");
        var qty = parseInt($(this).attr("data-quantity"));
        var url = "/cart/change.js";
        if ($(this).text() == "+") {
            qty = 1;
            url = "/cart/add.js";
        } else if ($(this).text() == "-") {
            qty = qty - 1;
        }

        $.ajax({
            type: "POST",
            url: url,
            dataType: "json",
            data: {
                id: parseFloat(idnaItem),
                quantity: qty,
            },
            success: function (success) {
                getCart();
                if(success?.items?.length === 0){
                    $('#box-pop-up-cart .total-price').html('');
                }
            },
            error: function (xhr, status, message) {
                $('.alert-error').show()
                setTimeout(() => {
                    $('.alert-error').hide()   
                }, 3000);
            },
        })
            // .then((data) => {
            //     getCart();
            // })
            // .catch((error) => {
            //     console.log('error',error)
            // });
    });
}

$(".form-add-to-cart").submit(function (event) {
    event.preventDefault();
    let data = $(this).attr("data-variant-id");
    let items = [{ id: data, quantity: 1 }];

    //Add to cart

    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: { items },
        success: function (success) {
               setTimeout(function () {
                getCart();
                $(".box-pop-up-cart").toggle();
            }, 400);
            setTimeout(function () {
                $(".box-pop-up-cart").hide();
            }, 4400);
        },
        error: function (error) {
            console.log("error", error);
        },
    })
});



// Product Template
$(".form-add-to-cart-product-template").click(function () {
    let id_from_param = $(
        ".form-add-to-cart-product-template input"
    ).val();
    let searchParams = new URLSearchParams(window.location.search);
    let id_from_url = searchParams.get("variant"); // true

    let id_variant = null;
    if (id_from_url == null) {
        id_variant = id_from_param;
    } else {
        id_variant = id_from_url;
    }

    let items = [{ id: id_variant, quantity: 1 }];

    //Add to cart

    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: { items },
        success: function (success) {
            setTimeout(function () {
                getCart();
                $(".box-pop-up-cart").toggle();
            }, 400);
            setTimeout(function () {
                $(".box-pop-up-cart").hide();
            }, 4400);
            $('.product-form__error-message-wrapper').addClass('product-form__error-message-wrapper--hidden')
        },
        error: function (message) {
            $('.product-form__error-message').html(message?.responseJSON?.description)
            $('.product-form__error-message-wrapper').removeClass('product-form__error-message-wrapper--hidden')
        },
    })
});

$('.quick-add .btn-add-cart-end-year').click(function(event) {
    event.preventDefault();

    const html = $(this).prev('.form-size-variant-wrapper').html();
    $.fancybox.open(html);
});

$(document).on('click', 'form.form-size-variant label.SizeSwatch', function (event) {
    var disableSwatch = $(this).attr('disabled');
    if(disableSwatch){
        return false;
    }
    $(this).prev('input').prop('checked', true);
});

$(document).on('submit', 'form.form-size-variant', function (event) {
    event.preventDefault();

    let varId = $(this).find('input:checked').val();
    // addItemToCartEndYear(varId, 1);
    let items = [{ id: varId, quantity: 1 }];
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: { items },
        success: function (success) {
   
             setTimeout(function () {
                $('.quick-add-alert-error').hide();
                getCart();
                $("[data-fancybox-close]").trigger("click");
                $(".box-pop-up-cart").toggle();
        }, 400);
        setTimeout(function () {
            $(".box-pop-up-cart").hide();
        }, 4400);
        },
        error: function (error) {
            $('.quick-add-alert-error').html(error?.responseJSON?.description)
            $('.quick-add-alert-error').show();
        },
    })

    $('.fancybox-slide').click(function () {
        $('.quick-add-alert-error').hide();
    })
    
    // .then((data) => {
    //     setTimeout(function () {
    //         getCart();
    //         $("[data-fancybox-close]").trigger("click");
    //         $(".box-pop-up-cart").toggle();
    //     }, 400);
    // })
    // .catch((error) => {
    //     console.log("error", error);
    // });
});


$('.menu-header-cart').click(function(){
    getCart();
    $('#box-pop-up-cart').show();
})
$('.cart-popup--close,.cart-pop-up-continue-shipping').click(function(){
    $('#box-pop-up-cart').hide();
})
if ($("div#voucher-wrapper").length > 0) {
	let getIdGroup = $('#voucher-wrapper').attr('group');
	let getIdCustomer = $('.get-customer-information').attr('customer-id');
	let currentUrl = window.location.href;
  	let getUrlStore = $('#voucher-wrapper').attr('url-shopify');
    let titlePage =  $('.get-customer-information').attr('page-title');

	$.ajax({
		type: "POST",
		url: "https://atmos-custom-plugin.devbdd.com/front/display_list_voucher",
		data: { id:getIdGroup,customerId:getIdCustomer,currentUrl:currentUrl,url_shopify:getUrlStore,titlePage:titlePage },
		success: function(response){
			$('#voucher-wrapper').append(response)

          if(currentUrl.includes('claim=failed')){
            $('#voucher-wrapper').prepend('<div class="voucher-wrappe-failed">Claim voucher failed! , pelase login first </div>');
          }
		}
	});
}

// sort order filter clothes
var order = ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl', 'xxl'];
var $wrapper = $('.filter-size:not(button)');
$wrapper.find('.span-filter').sort(function(a, b) {
    var aSize = $(a).data('sort'), bSize = $(b).data('sort');
    return order.indexOf(aSize) - order.indexOf(bSize);
}).appendTo($wrapper);

let remove_watermark = setInterval(() => {
  if($("#AccessibleNav .gm-submenu-mega p").length){
    $("#AccessibleNav .gm-submenu-mega p").remove()
  }
}, 1000)

setTimeout(() => {
  clearInterval(remove_watermark)
}, 10000)

if($(".search-form__input").length){
    $('.search-form__input').on('input', function() {
        let query = $(this).val().trim();

        if (query.length < 3) {
            // $('#search-results').empty().hide();
            return;
        }

        $.ajax({
            type: 'GET',
            url: `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[options][unavailable_products]=hide&resources[limit]=4`,
            dataType: 'json',
            success: function(data) {
                let results = data.resources.results.products;
                
                if (results.length > 0) {
                    let list_product = ``
                    results.forEach(function (product) {
                        list_product += `
                            <li id="search-result-0" class="predictive-search-item" role="option" data-search-result="">
                                <a class="predictive-search-item__link" href="${product.url}" tabindex="-1">
                                    <div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper="">
                                        <div class="placeholder-background placeholder-background--animation hide" data-image-placeholder="" aria-hidden="true"></div>
                                            <img class="predictive-search-item__image ls-is-cached lazyloaded" src="${product.featured_image.url}" data-image="" alt="${product.title}">
                                    </div>
                                    <div class="predictive-search__column predictive-search__column--content predictive-search__column--center">
                                        <span class="predictive-search-item__title">
                                            <span class="predictive-search-item__title-text">${product.title}</span>
                                        </span>
                                    </div>
                                </a>
                            </li>
                        `;
                    });

                    let find_search_wrapper = setInterval(() => {
                        if($(".predictive-search-wrapper .predictive-search").length){
                            $(".predictive-search-wrapper .predictive-search").html(`
                                <div class="predictive-search-title">
                                    <h3 id="predictive-search" class="predictive-search-title__content">Products</h3>
                                    <span class="predictive-search-title__loading-spinner"></span>
                                </div>
                                <ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">
                                    ${list_product}
                                    <li id="search-all" class="predictive-search-view-all" role="option" data-search-result="">
                                        <a href="/search?q=${query}&type=product" class="predictive-search-view-all__button" tabindex="-1">Search for <span class="predictive-search-view-all__query">“${query}”</span>
                                        </a>
                                    </li>
                                </ul> 
                            `)

                            clearInterval(find_search_wrapper)
                        }
                    }, 0);
                }
            },
            error: function(error) {
                console.error('Search error:', error);
            }
        });
    });
}